import type { FaireProductEntity } from "../../entity_types/product";

export const p_cwm2vhphm6: FaireProductEntity = {
  token: "p_cwm2vhphm6",
  type: "product",
  name: "rocky's matcha Measuring Spoon",
  brandToken: "b_jkddc7grcu",
  brandName: "rocky's matcha",
  imageUrl: "https://cdn.faire.com/fastly/89a76a2e6aa492fa1ac9bc5dd42c2fb435a9358ae09fe18a72a58f5f3bdc198b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c55f6789fd33d590810d77ecce9d58c3794994efb67e3c44105fbe5e1e5db4a8.jpeg",
    "https://cdn.faire.com/fastly/33c22ad905071fdc32bba42eeec093c213ee4df5f1163cb38772080e3276bd04.jpeg"
  ],
  priceDollars: 8,
  description: "\nMade from stainless steel, our branded measuring spoon measures approximately 1.5g of matcha per scoop. We use 2 spoonfuls for a perfect 3g serving of matcha.\n",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:21.640Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
